function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { createContext, useEffect, useMemo, useState } from 'react';
import Log from '@deephaven/log';
import { DEFAULT_PRELOAD_DATA_VARIABLES } from "./ThemeModel.js";
import { calculatePreloadStyleContent, getActiveThemes, getDefaultBaseThemes, setThemePreloadData, overrideSVGFillColors, getDefaultSelectedThemeKey } from "./ThemeUtils.js";
import { SpectrumThemeProvider } from "./SpectrumThemeProvider.js";
import "./theme-svg.css";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('ThemeProvider');
export var ThemeContext = /*#__PURE__*/createContext(null);
ThemeContext.displayName = 'ThemeContext';
export function ThemeProvider(_ref) {
  var customThemes = _ref.themes,
    _ref$waitForActivatio = _ref.waitForActivation,
    waitForActivation = _ref$waitForActivatio === void 0 ? false : _ref$waitForActivatio,
    _ref$defaultPreloadVa = _ref.defaultPreloadValues,
    defaultPreloadValues = _ref$defaultPreloadVa === void 0 ? DEFAULT_PRELOAD_DATA_VARIABLES : _ref$defaultPreloadVa,
    children = _ref.children;
  var baseThemes = useMemo(() => getDefaultBaseThemes(), []);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(getDefaultSelectedThemeKey),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedThemeKey = _useState4[0],
    setSelectedThemeKey = _useState4[1];

  // Calculate active themes once a non-null themes array is provided.
  var activeThemes = useMemo(() => customThemes == null ? null : getActiveThemes(selectedThemeKey, {
    base: baseThemes,
    custom: customThemes !== null && customThemes !== void 0 ? customThemes : []
  }), [baseThemes, selectedThemeKey, customThemes]);
  var themes = useMemo(() => [...baseThemes, ...(customThemes !== null && customThemes !== void 0 ? customThemes : [])], [baseThemes, customThemes]);
  useEffect(function updateThemePreloadData() {
    // Don't update preload data until themes have been loaded and activated
    if (activeThemes == null || customThemes == null) {
      return;
    }

    // Override fill color for certain inline SVGs (the originals are provided
    // by theme-svg.scss)
    overrideSVGFillColors(defaultPreloadValues);
    var preloadStyleContent = calculatePreloadStyleContent(defaultPreloadValues);
    log.debug2('updateThemePreloadData:', {
      active: activeThemes.map(theme => theme.themeKey),
      custom: customThemes.map(theme => theme.themeKey),
      preloadStyleContent,
      selectedThemeKey
    });
    setThemePreloadData({
      themeKey: selectedThemeKey,
      preloadStyleContent
    });
  }, [activeThemes, selectedThemeKey, customThemes, defaultPreloadValues]);
  useEffect(() => {
    setValue({
      activeThemes,
      selectedThemeKey,
      themes,
      setSelectedThemeKey
    });
  }, [activeThemes, selectedThemeKey, themes]);
  if (waitForActivation && activeThemes == null) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [activeThemes == null ? null : /*#__PURE__*/_jsx(_Fragment, {
      children: activeThemes.map(theme => /*#__PURE__*/_jsx("style", {
        "data-theme-key": theme.themeKey,
        children: theme.styleContent
      }, theme.themeKey))
    }), value == null ? null : /*#__PURE__*/_jsx(ThemeContext.Provider, {
      value: value,
      children: /*#__PURE__*/_jsx(SpectrumThemeProvider, {
        children: children
      })
    })]
  });
}
export default ThemeProvider;
//# sourceMappingURL=ThemeProvider.js.map